import React from "react";

import { Box, Button, Typography } from "@braintrust/braintrust-ui-components";
import { UserAvatar } from "@js/components/user-avatar";
import type { NoteItem } from "@js/types/admin";
import type { User } from "@js/types/auth";
import { exactDateFromNow } from "@js/utils";

import styles from "./style.module.scss";

export type JobBidCommentProps = {
  comment: NoteItem;
  bidId: number;
  onDelete: (note: NoteItem, bidId: number) => void;
};

export const JobBidComment = ({
  comment,
  bidId,
  onDelete,
}: JobBidCommentProps) => {
  return (
    <Box className={styles.comment}>
      <Box className={styles.commentAvatar}>
        <UserAvatar
          user={comment.user as User}
          className={styles.commentUserAvatar}
          hideBorder
        />
      </Box>

      <Box className={styles.commentDetails}>
        <Typography component="p" variant="label" multipleEllipsis size="small">
          {`${comment.user.first_name} ${comment.user.last_name}`}
        </Typography>
        <Typography
          component="p"
          size="small"
          sx={{ whiteSpace: "nowrap" }}
          color="grey"
        >
          {exactDateFromNow(comment.created)}
        </Typography>
      </Box>
      <Box className={styles.commentContent}>
        <Typography component="p" hyphens size="small">
          {comment.content}
        </Typography>
      </Box>

      {comment.can_user_delete && (
        <Button
          sx={{
            marginBottom: "auto",
            marginLeft: { sm: "initial", xs: "auto" },
          }}
          size="x-small"
          variant="transparent-blue"
          onClick={() => onDelete(comment, bidId)}
        >
          Delete
        </Button>
      )}
    </Box>
  );
};
